import { useEffect, useState } from "react";
import Api from "../api/Api";

export default function useFiles(uuids: string[], api: Api, deps?: React.DependencyList) {
  const [fileUriDict, setFileUris] = useState<Record<string, string>>();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setFileUris(undefined);
    let objectUrls: Record<string, string> = {};
    if (uuids.length === 0) {
      setFileUris(objectUrls);
      return;
    }

    let isMounted = true;

    setLoading(true);
    api
      .getFiles(uuids)
      .then((files) => {
        if (!isMounted) return;
        for (const { blob, uuid } of files ?? []) {
          const objectUrl = URL.createObjectURL(blob);
          objectUrls[uuid] = objectUrl;
        }

        setFileUris(objectUrls);
      })
      .finally(() => setLoading(false));

    return () => {
      isMounted = false;
      for (const url of Object.values(objectUrls)) {
        URL.revokeObjectURL(url);
      }
    };
  }, deps ?? []);
  return { fileUriDict, loading };
}
